import React from 'react'

type ChatAccount = {
  id: number
  login: string
  organisationId: number
}

export type User = {
  admin: boolean
  avatar: string
  chatAccounts: ChatAccount[]
  guest: boolean
  id: number
  name: string
  online: boolean
  removed: boolean
  supervisor: boolean
}

type State = {
  users: User[]
  get: (id: number) => User | undefined
  getByXmpp: (xmpp: string) => User | undefined
}

export const UsersManagerContext = React.createContext<State>({
  users: [],
  get: () => undefined,
  getByXmpp: () => undefined,
})

type Props = {
  users: User[]
  children: React.ReactNode
}

const UsersManager: React.FC<Props> = ({ users, children }) => {
  const get = (id: number) => users.find(user => user.id == id)
  const getByXmpp = (xmpp: string) =>
    users.find(user => user.chatAccounts.find(account => account.login == xmpp))

  window.getUserByXmpp = getByXmpp

  return (
    <UsersManagerContext.Provider
      value={{
        users,
        getByXmpp,
        get,
      }}
    >
      {children}
    </UsersManagerContext.Provider>
  )
}

export default UsersManager
